'use client'
import { getShops } from '@/app/controllers/categoryCtrl'
import CategoryButton from '@/components/category_button'
import ProductCard from '@/components/product_card'
import { atom, useAtom } from 'jotai'
import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { shopId } from '../stores/storage'

import localFont from 'next/font/local'
const font = localFont({ src: '../../public/fonts/hanachi.ttf' })

type DataType = Awaited<ReturnType<typeof getShops>>

export default function Home() {
  const [data, setData] = useState<DataType>()
  const [currentShop, setCurrentShop] = useAtom(shopId)
  const [currentCategory, setCurrentCategory] = useState<number>()

  const getData = async () => {
    const res = await getShops()

    setData(res)
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <main className={`${font.className}`}>
      {data && (
        <div className="flex bg-gray-100 justify-center">
          <div className="flex flex-col w-full max-w-5xl">
            <div className="flex">
              <div className="w-[70vw] h-[calc(100vh)] sticky top-0 overflow-y-scroll overscroll-contain bg-black">
                <div className="flex flex-col bg-[url('/images/pattern.svg')] p-6 gap-5 min-h-[100vh]">
                  {data.shops
                    .find((item) => item.id == currentShop)
                    ?.categories.find((item) => item.id == currentCategory)
                    ?.products.map((item) => {
                      return (
                        <ProductCard
                          key={item.id}
                          title={item.title}
                          content={item.content as string}
                          price={item.price.toLocaleString()}
                          image={item.imageUrl || '/images/products/empty.png'}
                        />
                      )
                    })}
                </div>
              </div>
              <div className="w-[30vw]" style={{ backgroundImage: "url('/images/darkback.png')" }}>
                <div className="sticky top-0 p-5 flex justify-center content-center z-50" style={{ backgroundImage: "url('/images/darkback.png')" }}>
                  <ul className="bg-white content-center place-content-between rounded-full">
                    {data.shops.map((item) => {
                      return (
                        <li key={item.id}>
                          <div
                            onClick={() => {
                              setCurrentShop(item.id)
                            }}
                            className={`${item.id == currentShop ? 'bg-[#EADF00]' : ''} p-2 m-1 rounded-full`}
                            data-tip={item.name}
                          >
                            <Image width={50} height={50} src={`${item.image}`} alt={item.id.toString()} />
                          </div>
                        </li>
                      )
                    })}
                  </ul>
                </div>
                <div className="overflow-y-scroll overscroll-contain">
                  {data.shops
                    .find((item) => item.id == currentShop)
                    ?.categories.map((item) => {
                      return (
                        <div
                          onClick={() => {
                            setCurrentCategory(item.id)
                          }}
                          key={item.id}
                        >
                          <CategoryButton name={item.name} image={`${item.image}`} active={currentCategory == item.id} />
                        </div>
                      )
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </main>
  )
}
